import ensureClaim from './ensure-claim.js'
import callCenter from './callCenter.js'
import custComplainApp from './custComplainApp.js'

export const coverConfig = [
  {
    url: '/client-portrait-app/wb/searchOrder', // 交易信息-运单记录
    coverFields: [
      {
        field: 'businessList',
        keys: [
          'driverName',
          'driverTel',
          'licenceNo',
          'shipperName',
          'shipperTel',
          'techServiceFeeAmount',
          'depositAmount',
          'useYmmPay',
          'loadAddress',
          'unloadingAddress',
          'freightAmount',
          'discountAmount',
          'paidAmount',
          'companyName',
          'userName',
          'telephone',
          'loadAddress',
          'unloadingAddress',
          'refundedAmount',
          'notRefundedAmount',
          'amount',
          'actualPayAmount',
          'couponAmount',
          'deductAmount',
          'deductCouponAmount',
          'deductPointsAmount',
          'pointsAmount',
          'commissionBalanceAmount',
          'deductCommissionBalanceAmount',
          'supplementAmount',
          'commissionExtraDesc',
          'refundAmount',
          'cancelFeeAmount',
          'discountAmount',
          'description'
        ],
        onlyMask: ['driverTel', 'shipperTel']
      }
    ]
  },
  {
    url: 'callCenter/customerInfo', // 用户信息
    coverFields: [
      // {
      //   field: 'customerDetail',
      //   keys: ['detailPlace','idCard','registerTelephone']
      // },
      {
        field: 'customerExtend',
        keys: ['name', 'companyPlace', 'licenceNo']
      }
    ]
  },
  {
    url: 'user/customerInfo', // 用户信息
    coverFields: [
      // {
      //   field: 'customerDetail',
      //   keys: ['detailPlace','idCard','registerTelephone']
      // },
      {
        field: 'customerExtend',
        keys: ['name', 'companyPlace', 'licenceNo']
      }
    ]
  },
  {
    url: 'wb/callCenter/orderInfo', // 业务信息获取订单接口
    coverFields: ['driverName', 'shipperName', 'shipperTel', 'driverTel', 'licenceNo']
  },
  {
    url: 'order/orderInfo', // 业务信息获取订单接口 新
    coverFields: ['driverName', 'shipperName', 'shipperTel', 'driverTel', 'licenceNo'],
    onlyMask: ['shipperTel', 'driverTel']
  },
  {
    url: 'wb/wallet/query/userVerifyAndBankCard', // 认证信息
    coverFields: ['realName', 'phoneNum', 'realName']
  },
  {
    url: 'user/wallet/query/userVerifyAndBankCard', // 认证信息 新
    coverFields: ['realName', 'phoneNum', 'realName']
  },
  {
    url: 'wb/wallet/query/userVerifyRecord', // 认证记录
    coverFields: ['tellPhone', 'certNum']
  },
  {
    url: 'user/wallet/query/userVerifyRecord', // 认证记录 新
    coverFields: ['tellPhone', 'certNum']
  },
  {
    url: 'wb/queryChangeMobileLog', // 手机号修改记录
    coverFields: [
      {
        field: 'data',
        keys: ['oldTelephone', 'newTelephone']
      }
    ]
  },
  {
    url: 'user/queryChangeMobileLog', // 手机号修改记录 新
    coverFields: [
      {
        field: 'data',
        keys: ['oldTelephone', 'newTelephone'],
        onlyMask: ['oldTelephone', 'newTelephone']
      }
    ]
  },
  {
    url: 'crm-access/record/historyCall',
    coverFields: [
      {
        field: 'callList',
        keys: ['customerTelephone', 'customerName', 'switchUserMobile', 'switchUserName'],
        onlyMask: ['customerTelephone', 'switchUserMobile']
      }
    ]
  },
  {
    url: 'wb/callCenter/historyWorkOrder',
    coverFields: [
      {
        field: 'orderList',
        keys: ['customerPhone', 'customerName', 'defendantName', 'defendantTel']
      }
    ]
  },
  {
    url: 'case/historyWorkOrder',
    coverFields: [
      {
        field: 'orderList',
        keys: ['customerPhone', 'customerName', 'defendantName', 'defendantTel'],
        onlyMask: ['customerPhone', 'defendantTel']
      }
    ]
  },
  {
    url: 'call-center/callCenter/historyWorkOrder',
    coverFields: [
      {
        field: 'orderList',
        keys: ['customerPhone', 'customerName', 'defendantName', 'defendantTel']
      }
    ]
  },
  // 查询工单
  {
    url: 'wb/callCenter/searchCase',
    coverFields: [
      {
        field: 'data',
        keys: ['userName', 'tel']
      }
    ]
  },
  // 查询工单 新
  {
    url: 'case/searchCase',
    coverFields: [
      {
        field: 'data',
        keys: ['userName', 'tel'],
        onlyMask: ['tel']
      }
    ]
  },
  // 查询保障理赔记录
  {
    url: 'wb/callCenter/queryEnsureClaimList',
    coverFields: [
      {
        field: 'content',
        keys: ['reportUserName', 'reportUserPhone', 'sideUserName', 'sideUserPhone']
      }
    ]
  },
  // 查询保障理赔记录 新
  {
    url: 'insurance/queryEnsureClaimList',
    coverFields: [
      {
        field: 'content',
        keys: ['reportUserName', 'reportUserPhone', 'sideUserName', 'sideUserPhone'],
        onlyMask: ['reportUserPhone', 'sideUserPhone']
      }
    ]
  },
  // 查询保险理赔记录
  {
    url: 'callCenter/queryInsuranceClaims',
    coverFields: [
      {
        field: 'content',
        keys: ['reporterTel', 'consignorTel', 'carNumber']
      }
    ]
  },
  // 查询保险理赔记录 新
  {
    url: 'insurance/queryInsuranceClaims',
    coverFields: [
      {
        field: 'content',
        keys: ['reporterTel', 'consignorTel', 'carNumber'],
        onlyMask: ['reporterTel', 'consignorTel']
      }
    ]
  },
  {
    url: 'crm-access/record/separateCalls',
    coverFields: [
      {
        field: 'callList',
        keys: ['customerTelephone', 'customerName', 'switchUserMobile', 'switchUserName'],
        onlyMask: ['customerTelephone', 'switchUserMobile']
      }
    ]
  },
  {
    url: 'call-center/callCenter/searchCustomer', // 切换账户搜索用户列表
    coverFields: [
      {
        field: 'customers',
        keys: ['idCard', 'name']
      }
    ]
  },
  {
    url: 'client-portrait-app/user/searchCustomer', // 切换账户搜索用户列表 (新)
    coverFields: [
      {
        field: 'customers',
        keys: ['idCard', 'name']
      }
    ]
  },
  {
    url: 'crm-access/record/completedOrder', // 完成业务单列表
    coverFields: [
      {
        field: 'callList',
        keys: ['customerTelephone', 'customerName', 'switchUserMobile', 'switchUserName'],
        onlyMask: ['customerTelephone', 'switchUserMobile']
      }
    ]
  },
  {
    url: 'crm-access/record/transferedOrder', // 完成业务单列表
    coverFields: [
      {
        field: 'callList',
        keys: ['customerTelephone', 'customerName', 'switchUserMobile', 'switchUserName'],
        onlyMask: ['customerTelephone', 'switchUserMobile']
      }
    ]
  },
  {
    url: '/cust-complain-app/complaints/orderList', // 催投诉/重开工单/崔拉白工单
    coverFields: [
      {
        field: 'orderList',
        keys: ['accuserName', 'accuserTel', 'defendantName', 'defendantTel']
      }
    ]
  },
  {
    url: 'call-center/server/callOrderList', // 服务单中心
    coverFields: [
      {
        field: 'callList',
        keys: ['customerTelephone', 'customerName']
      }
    ]
  }
]
  .concat(ensureClaim)
  .concat(callCenter)
  .concat(custComplainApp)
